import { useState } from "react";
import { useMessagingSettings } from "./useMessagingSettings";
import MessageDelayDisabledInfo from "./MessageDelay/MessageDelayDisabledInfo";
import { Button } from "V2.0/common/button";
import InputComponent from "V2.0/components/InputComponent";

export default function MessageDelay(props) {
  const { messagingSettings, syncAssistant, workspaceId, assistantId, locked } =
    props;
  const { loading, setLoading, updateMessagingSettings } = useMessagingSettings(
    {
      syncAssistant,
      workspaceId,
      assistantId,
    }
  );
  const [settings, setSettings] = useState({
    messageDelay: messagingSettings?.messageDelay || 0,
  });
  const [errors, setErrors] = useState({
    messageDelay: null,
  });

  function handleUpdateError(updatedError) {
    setErrors((prevErrors) => {
      return {
        ...prevErrors,
        ...updatedError,
      };
    });
  }

  function handleUpdateSettings(updatedSetting) {
    setSettings((prevSettings) => {
      return { ...prevSettings, ...updatedSetting };
    });
  }

  function handleUpdateMessageDelay(messageDelay) {
    if (Number(messageDelay) > 5000 && !Boolean(errors.messageDelay)) {
      handleUpdateError({
        messageDelay: "Maximum Delay is 5000 Seconds",
      });
    }

    if (Number(messageDelay) < 5000 && Boolean(errors.messageDelay)) {
      handleUpdateError({
        messageDelay: null,
      });
    }

    handleUpdateSettings({
      messageDelay,
    });
  }

  const handleSave = () => {
    updateMessagingSettings(settings);
  };

  const isSaveDisabled = Object.values(errors).some((value) => Boolean(value));

  return (
    <div className="flex flex-col w-3/5 min-w-[600px] gap-y-2 border rounded-lg m-4">
      <div className="px-6 py-4 bg-gray-50 rounded-t-lg">
        <p className="text-md font-semibold text-gray-900">Response Delay</p>
        <p className="text-sm mt-1 text-gray-500">
          Configure a delay to make replies feel more natural
        </p>
      </div>

      <div className="grid grid-cols-3 px-6 space-y-2 py-4">
        <div className="col-span-3 xl:col-span-2">
          <InputComponent
            type="number"
            label="Delay (Seconds)"
            value={settings.messageDelay}
            disabled={
              locked ||
              messagingSettings?.documentCollectionSettings?.documentCollection
            }
            onChange={(e) => handleUpdateMessageDelay(e.target.value)}
          />
        </div>
        {messagingSettings?.documentCollectionSettings?.documentCollection && (
          <div className="col-span-3">
            <MessageDelayDisabledInfo />
          </div>
        )}
        {errors.messageDelay && (
          <p className="text-sm text-red-500 col-span-3">
            {errors.messageDelay}
          </p>
        )}
      </div>

      <div className="bg-gray-50 px-6 py-3 text-right rounded-b-lg">
        {!locked && (
          <Button
            onClick={handleSave}
            disabled={isSaveDisabled}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
}
